'use client'

import Image from 'next/image'
import Link from 'next/link'
import { LuArrowRight } from 'react-icons/lu'

type CultureHeroSectionProps = {
    className?: string;
}

const RECRUITMENT_ID = process.env.NEXT_PUBLIC_RECRUITMENT_ID;

const CultureHeroSection: React.FC<CultureHeroSectionProps> = ({ className = '' }) => {
    return (
        <section className={`w-full flex flex-col pt-8 md:pt-0 md:block md:relative h-auto md:h-[90vh] min-h-0 md:min-h-[550px] min-[1920px]:min-h-[800px] overflow-hidden ${className}`}>

            {/* --- 1. ẢNH NỀN --- */}
            <div className="relative w-full h-[40vh] min-h-[250px] md:min-h-0 md:absolute md:inset-0 md:h-full bg-white md:bg-transparent">
                <Image
                    src="/images/TD.png"
                    alt="Team building Rovi Holding"
                    fill
                    className="object-contain md:object-cover object-center"
                    priority
                    sizes="100vw"
                />
            </div>

            {/* Overlay Gradient (Desktop Only) */}
            <div className="hidden md:block absolute inset-0 bg-gradient-to-b from-black/10 via-black/20 to-black/40" />

            {/* --- 2. NỘI DUNG TEXT --- */}
            <div className="relative w-full md:absolute z-10 flex flex-col items-center justify-start md:justify-end h-auto md:h-full text-center bg-white md:bg-transparent px-4 pt-0 -mt-2 pb-6 md:mt-0 md:pt-4 md:pb-8 xl:px-16 xl:pb-8 2xl:pb-12 min-[1920px]:pb-20">

                <div className="w-full max-w-5xl 2xl:max-w-6xl min-[1920px]:max-w-[90rem] mx-auto">

                    {/* Subtitle */}
                    <h3 className="text-[10px] md:text-[11px] xl:text-xs 2xl:text-sm min-[1920px]:text-xl font-normal text-gray-500 md:text-white uppercase tracking-[3px] mb-2 md:mb-3 min-[1920px]:mb-5 md:drop-shadow-lg">
                        Văn hóa Rovi Holdings
                    </h3>

                    {/* Title */}
                    <h1 className="text-xl md:text-2xl xl:text-2xl 2xl:text-4xl min-[1920px]:text-6xl font-medium text-gray-900 md:text-white uppercase leading-tight mb-3 md:mb-5 min-[1920px]:mb-8 tracking-tight md:drop-shadow-2xl">
                        DẤN THÂN, TRÁCH NHIỆM, HIỆU QUẢ
                    </h1>

                    {/* Description */}
                    <p className="text-[11px] md:text-[11px] xl:text-xs 2xl:text-sm min-[1920px]:text-lg text-gray-600 md:text-white font-light max-w-[90%] md:max-w-[650px] xl:max-w-[750px] 2xl:max-w-[900px] min-[1920px]:max-w-[1200px] mx-auto mb-6 md:mb-7 min-[1920px]:mb-12 leading-relaxed md:drop-shadow-lg">
                        Nhân sự được xem là yếu tố nòng cốt, tiên quyết cho sự phát triển vững mạnh của tập đoàn, Rovi Holdings không ngừng nỗ lực để hoàn thiện hệ thống nhân sự chất lượng, tạo ra một môi trường làm việc năng động, đoàn kết, công bằng và chuyên nghiệp.
                    </p>

                    {/* Button */}
                    <Link
                        href="/news?tuyen-dung"
                        className="inline-flex items-center gap-2 bg-green-700 hover:bg-red-600 text-white px-4 py-2 2xl:px-6 2xl:py-3 min-[1920px]:px-8 min-[1920px]:py-4 text-xs xl:text-sm 2xl:text-base min-[1920px]:text-xl font-medium rounded-full transition-colors duration-300"
                    >
                        Gia nhập Rovi Holdings
                        <LuArrowRight className="size-3 md:size-3.5 xl:size-4 2xl:size-5 min-[1920px]:size-6" />
                    </Link>
                </div>
            </div>
        </section>
    )
}

export default CultureHeroSection